import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';

const { palette } = lightTheme;
const styles: Record<string, SxProps> = {
  base: {
    maxWidth: '14rem',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '0.875rem',
    letterSpacing: '3%',
    textAlign: 'left',
    color: palette.grey['50'],
    backgroundColor: palette.grey.main,
    borderRadius: '0.25rem',
    padding: '1rem',
    border: '0.0625rem solid transparent',
    svg: {
      width: '1.0625rem',
      marginRight: '0.625rem'
    },
    display: 'flex',
    alignItems: 'center',
    // global class to style tooltip arrow
    '.MuiTooltip-arrow': {
      '&:before': {
        backgroundColor: palette.grey.main
      }
    }
  },

  titleStyles: {
    display: 'flex',
    alignItems: 'center'
  }
};

export default styles;
